export default __webpack_public_path__ + "static/media/sa-relive-264.1217a45c.mov";